module.exports = __webpack_public_path__ + "img/v2.fc1325ba.png";